import fields from '@src/entities/ActionPath/includes/fields.json';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { TextInputArea } from '@uhg-abyss/web/ui/TextInputArea';
import React from 'react';

const { notes: notesField } = fields;

/**
 * Field: Notes
 *
 * Add notes to the action path.
 *
 * @param form
 * @returns {Element}
 * @constructor
 */
export function Notes({
  form = {
    validate: () => {},
  },
}) {
  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/fields/Notes/Notes.jsx">
      <TextInputArea
        {...notesField}
        onChange={() => {
          form?.validate(
            `remediation[notes]`,
            () => {},
            () => {}
          );
        }}
      />
    </ErrorHandler>
  );
}
